import React from 'react';
import styles from './Home.module.css';
import csfLogo from '../images/HonorSocietyTutorsLogo.png';
import Header from '../components/Header';
import gettingStarted from '../images/Getting Started.png';

export default function Home() {
  return (
    <div className={styles.container}>
      <Header />

      {/* Hero Section */}
      <section className={styles.hero}>
        <div className={styles.heroContent}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <img src={csfLogo} alt="CSF Tutors Logo" className={styles.heroLogo} />
            <div className={styles.heroText}>Honor society tutors from your high school</div>
          </div>
        </div>
      </section>

      {/* Get Started CTA */}
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        marginTop: '2rem',
        marginBottom: '2rem'
      }}>
        <a
          href="/directory"
          style={{
            backgroundColor: '#04d664',
            color: 'white',
            padding: '1.2rem 3rem',
            borderRadius: '40px',
            textDecoration: 'none',
            fontSize: '2rem',
            fontWeight: '600',
            transition: 'all 0.2s',
            boxShadow: '0 2px 8px rgba(4, 214, 100, 0.3)',
            display: 'inline-block',
            minHeight: '88px',
            display: 'flex',
            alignItems: 'center'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#029c47';
            e.target.style.transform = 'translateY(-1px)';
            e.target.style.boxShadow = '0 4px 12px rgba(4, 214, 100, 0.4)';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#04d664';
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 2px 8px rgba(4, 214, 100, 0.3)';
          }}
        >
          Get Started
        </a>
      </div>

      {/* Getting Started Section - Single Image */}
      <section className={styles.howItWorks}>
        <div className={styles.howContent}>
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: '3rem'
          }}>
            <img
              src={gettingStarted}
              alt="Getting Started"
              style={{
                width: '100%',
                maxWidth: '800px',
                height: 'auto',
                borderRadius: '12px',
                boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
              }}
            />
          </div>
        </div>
      </section>
    </div>
  );
}
